module.exports = __webpack_public_path__ + "static/media/skila-bg_img-02-4-pod_600px_width-0_1-@3x.6d9210b9.png";